import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import { Table, Skeleton } from "@mantine/core";
import { formatPrice } from "./util";

const DetailQuery = gql`
  query DetailQuery($id: ID) {
    details(id: $id) {
      id
      articles {
        articleId
        articleKey
        articleName
        priceExclVat
        priceInclVat
      }
    }
  }
`;

const Article = (props) => {
  const { sale } = props;
  const [articles, setArticles] = useState();
  const language = useSelector((state) => state.language);

  const { data, loading } = useQuery(DetailQuery, {
    variables: {
      id: sale.receiptNumber,
    },
  });
  useEffect(() => {
    if (!data) return;
    setArticles(data.details.articles);
  }, [data]);

  const tableHeads = (
    <tr>
      <th>{language.Sale_Details["article"]}</th>
      <th>{language.Sale_Details["vat"]}</th>
      <th>{language.Sale_Details["amount"]}</th>
    </tr>
  );

  if (loading) return <Skeleton style={{ minHeight: "200px" }} />;

  return (
    <Table withBorder striped>
      <thead>{tableHeads}</thead>
      <tbody>
        {articles &&
          articles.map((article, i) => {
            const vat = Number(
              article.priceInclVat - article.priceExclVat
            ).toFixed(2);
            return (
              <tr key={i}>
                <td>{article.articleName}</td>
                <td>{formatPrice(vat)}</td>
                <td>{formatPrice(article.priceInclVat)}</td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export default Article;
